import { useState, React, Fragment } from "react";
import { Dialog, Popover } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { UilWallet } from "@iconscout/react-unicons";

import {
  PhoneArrowUpRightIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/solid";
import UserMenu from "./UserMenu";
import { Outlet, Link } from "react-router-dom";
import CartIconComponent from "../../spa/shop/CartIconComponent";
import CartDropDownComponent from "../../spa/shop/CartDropDownComponent";

import { useContext } from "react";
import { UserContext } from "../../context/user.context";
import { CartContext } from "../../context/cart.context";
import { UilWhatsapp } from "@iconscout/react-unicons";

import Logo from "./responsiveLogo";

const solutions = [
  { name: "Promotions", href: "/promotions" },
  { name: "How it Works", href: "/howitworks" },
];

const navigation = [
  { name: "Home", href: "/" },
  { name: "About Zulal", href: "/About" },
  { name: "Promotions", href: "/Promotions" },
  { name: "Zulal Store", href: "/productsrange" },
  { name: "News & Media", href: "/NewsMedia" },
  { name: "Contact Us", href: "/ContactUs" },
  { name: "Suggestion / Complaints", href: "/user/complaintpage" },
];

export default function NavbarUI() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { currentUser } = useContext(UserContext);
  const { isCartOpen, setIsCartOpen } = useContext(CartContext);
  const [showCart, setShowCart] = useState(false);

  const handlePromotions = () => {
    window.location.href = "/promotions";
  };

  return (
    <Fragment>
      <header className="sticky top-0 z-[20] bg-textWhite font-poppins">
        <div className="sticky top-0 mx-auto max-w-screen-xl">
          <header className="bg-textWhite text-primary dark:bg-darkBase dark:text-secondary ">
            <nav
              className="mx-auto flex relative items-center justify-between gap-x-6 p-6 lg:px-20 "
              aria-label="Global"
            >
              <Logo />
              {/** Main menu  */}
              <div className="hidden lg:flex lg:gap-x-4 ">
                {navigation.map((item) => {
                  if (item.name === "Promotions") {
                    return (
                      <Popover className="relative" key={item.name}>
                        <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
                          <span>{item.name}</span>
                          <ChevronDownIcon
                            aria-hidden="true"
                            className="h-5 w-5"
                          />
                        </Popover.Button>

                        <Popover.Panel
                          transition
                          className="absolute left-1/2 z-10 mt-2 flex w-screen max-w-min -translate-x-1/2 px-4 transition 
                          data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                          <div className="w-40 shrink rounded-xl bg-textWhite p-2 text-[14px] font-semibold leading-2 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                            {solutions.map((item) => (
                              <a
                                key={item.name}
                                href={item.href}
                                className="block p-2 hover:text-indigo-600"
                              >
                                {item.name}
                              </a>
                            ))}
                          </div>
                        </Popover.Panel>
                      </Popover>
                    );
                  }
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "smooth",
                        });
                      }}
                      state={{ PageTitle: item.name }}
                      className="text-sm font-semibold leading-6 hover:text-primaryHover dark:hover:text-secondaryHover"
                    >
                      {item.name}
                    </Link>
                  );
                })}
              </div>

              {/** CTA  */}
              <div className="flex flex-1 items-center justify-end gap-x-3">
                <span className="hidden text-xl font-semibold">عربي</span>
                <div className="sm:w-[1px] h-10 bg-primary dark:bg-secondary"></div>

                <span className="sr-only">Zulal Wallet</span>
                <Link
                  state={{ PageTitle: "STAY TUNED" }}
                  to="/user/zulalwallet"
                  className="flex rounded-full bg-primary h-8 w-8 xl:w-10 xl:h-10 text-textWhite items-center justify-center
      hover:bg-primaryHover focus:outline-none focus:ring-2 focus:ring-secondary"
                  aria-hidden="true"
                >
                  <UilWallet className="w-6 h-6" />
                </Link>

                <UserMenu />

                <CartIconComponent
                  onClick={() => {
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                    setShowCart(true);
                  }}
                />
              </div>

              <div className="flex lg:hidden items-center">
                <button
                  type="button"
                  className="bg-primary w-8 h-8 text-textWhite hover:bg-primaryHover focus:outline-none focus:ring-2 focus:ring-secondary 
         inline-flex items-center justify-center rounded-full -m-2.5 p-1"
                  onClick={() => setMobileMenuOpen(true)}
                >
                  <span className="sr-only">Open main menu</span>
                  <Bars3Icon className="w-6 h-6" aria-hidden="true" />
                </button>
              </div>
            </nav>

            <CartDropDownComponent
              showCart={showCart}
              onClose={() => {
                setShowCart(false);
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "smooth",
                });
              }}
            />

            <Dialog
              as="div"
              className="lg:hidden"
              open={mobileMenuOpen}
              onClose={() => setMobileMenuOpen(false)}
            >
              <div className="fixed inset-0 z-[25]" />
              <Dialog.Panel
                className="fixed inset-y-0 right-0 z-[25] myW-full overflow-y-auto bg-textwhite 
                                       px-6 py-6 sm:max-w-sm sm:myring-1 sm:ring-gray-900/10"
              >
                <div className="flex items-center gap-x-6 ">
                  <Link
                    to={"/"}
                    className="-m-1.5 p-1.5 "
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });

                      setMobileMenuOpen(false);
                    }}
                  >
                    <span className="sr-only">Zulal Water Company</span>
                    <Logo />
                  </Link>
                  {currentUser.isloggedIn === true ? (
                    <Link
                      to={"/user/logout"}
                      state={{ PageTitle: "Log Out" }}
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "smooth",
                        });
                        setMobileMenuOpen(false);
                      }}
                      className="ml-auto bg-primary rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-textWhite shadow-sm hover:bg-indigo-500 
                  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Log Out
                    </Link>
                  ) : (
                    <Link
                      to={"/createuser"}
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "smooth",
                        });
                        setMobileMenuOpen(false);
                      }}
                      className="ml-auto bg-primary rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-textWhite shadow-sm hover:bg-indigo-500 
                  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Sign up
                    </Link>
                  )}
                  <button
                    type="button"
                    className=" -m-2.5 rounded-md p-2.5 text-gray-700"
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                      setMobileMenuOpen(false);
                    }}
                  >
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-10 w-10" aria-hidden="true" />
                  </button>
                </div>
                <div className="mt-6 flow-root">
                  <div className="-my-6 divide-y divide-gray-500/10">
                    <div className="space-y-2 py-6">
                      {navigation.map((item) => {
                        if (item.name === "Promotions") {
                          return (
                            <Popover className="relative">
                              <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
                                <span>{item.name}</span>
                                <ChevronDownIcon
                                  aria-hidden="true"
                                  className="h-5 w-5"
                                />
                              </Popover.Button>

                              <Popover.Panel
                                transition
                                className="absolute left-1/2 z-10 mt-2 flex w-screen max-w-min -translate-x-1/2 px-2 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                              >
                                <div className="w-40 shrink rounded-xl bg-textWhite p-2 text-C12 font-semibold leading-2 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                                  {solutions.map((item) => (
                                    <a
                                      key={item.name}
                                      href={item.href}
                                      className="block p-2 hover:text-indigo-600"
                                    >
                                      {item.name}
                                    </a>
                                  ))}
                                </div>
                              </Popover.Panel>
                            </Popover>
                          );
                        }
                        return (
                          <Link
                            key={item.name}
                            to={item.href}
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "smooth",
                              });
                              setMobileMenuOpen(false);
                              //console.log("Clicked:", item.name);
                            }}
                            state={{ PageTitle: item.name }}
                            className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                          >
                            {item.name}
                          </Link>
                        );
                      })}
                    </div>
                    <div className="py-6">
                      {currentUser.isloggedIn ? (
                        <label className="font-medium font-poppins text-base text-navarbarText text-center">
                          Welcome{" "}
                          {!currentUser.isloggedIn
                            ? ""
                            : currentUser.outletName}
                        </label>
                      ) : (
                        <Link
                          to={"/login"}
                          onClick={() => {
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                            //console.log("Clicked on login");
                            setMobileMenuOpen(false);
                          }}
                          className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                        >
                          Log in
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Dialog>
          </header>
        </div>
      </header>
      <main>
        <Outlet />
      </main>

      <Link
        to="https://api.whatsapp.com/send/?phone=971600556666&text&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        className="w-20 h-20 bg-primary"
      >
        <UilWhatsapp className="w-16 h-16 hover:text-green-500 hover:scale-105 text-green-700 z-30 fixed bottom-10  md:left-10 left-2" />
      </Link>
    </Fragment>
  );
}
